import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useCheckInHeatmap } from 'app/javascript/queries/useProfiles';
import { Popover, PopoverContent, PopoverTrigger } from 'app/javascript/components/ui/popover';
import AttendanceFlame from 'app/javascript/components/shared/AttendanceFlame';
import {
  getHeatmapThresholds,
  getHeatmapLegendBuckets,
  HEATMAP_BUCKET_STYLES,
} from 'app/javascript/services/heatmap';

interface HeatmapLegendTriggerProps {
  slug: string;
  companySlug: string;
}

const SWATCH_CLASS =
  'flex h-9 min-w-[40px] items-center justify-center rounded text-sm font-bold';

const SWATCH_RING: Partial<Record<keyof typeof HEATMAP_BUCKET_STYLES, string>> = {
  empty: 'ring-1 ring-slate-700/40',
};

const HeatmapLegendTrigger: React.FC<HeatmapLegendTriggerProps> = ({ slug, companySlug }) => {
  const { data } = useCheckInHeatmap(slug, companySlug);
  const thresholds = getHeatmapThresholds(data?.weekly_class_days);
  const buckets = getHeatmapLegendBuckets(thresholds);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="O que estes números representam?"
          className="inline-flex items-center justify-center rounded-full text-slate-400 transition-colors hover:text-yellow-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/60"
        >
          <HelpCircle className="size-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="left" align="start" className="w-80">
        <div className="space-y-3">
          <p className="text-base font-semibold text-white">Quantidade de treinos na semana</p>
          <div className="flex flex-col gap-2">
            {buckets.map((bucket) => {
              const style = HEATMAP_BUCKET_STYLES[bucket.key];
              return (
              <div key={bucket.key} className="flex items-center gap-2">
                <div className={`${SWATCH_CLASS} ${style.bg} ${style.text} ${SWATCH_RING[bucket.key] || ''}`}>
                  {bucket.key === 'full' ? <AttendanceFlame className={style.text} /> : bucket.label}
                </div>
                <span className="text-base text-white/85">
                  {bucket.key === 'full'
                    ? `${bucket.label} treinos (semana cheia)`
                    : bucket.label === '1'
                      ? 'treino'
                      : 'treinos'}
                </span>
              </div>
              );
            })}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default HeatmapLegendTrigger;
